import React from "react";
import Link from "gatsby-link";
import styled, { ThemeProvider } from "styled-components";
import { rgba, shade } from "polished";
import { Flex, Text as RebassText, Box } from "rebass";
import theme from "../theme";

const Wrapper = styled(Flex)`
  position: relative;

  &:hover,
  &.focused {
    > div {
      transform: scaleY(1);
      opacity: 1;
      z-index: 100;
    }
  }
`;
Wrapper.defaultProps = {
  align: "center",
  flexDirection: "column"
};

const Parent = styled(RebassText)`
  cursor: pointer;
  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1);
  will-change: color;
  user-select: none;

  &:hover {
    color: ${props => props.theme.colors.violet};
  }
  &:active {
    color: ${props =>
      props.theme.colors.text && shade(0.875, props.theme.colors.violet)};
  }
`;
Parent.defaultProps = {
  is: Link,
  m: 0,
  px: 2,
  py: 3,
  color: "text",
  fontSize: 16,
  fontWeight: "bold",
  lineHeight: 3
};

const Container = styled(Box)`
  position: absolute;
  top: 56px;
  left: -16px;
  width: max-content;
  min-width: ${16 * 10}px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  transform: scaleY(0);
  transform-origin: top;
  opacity: 0;
  background-color: ${props => props.theme.colors.grey[2]};
  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);
`;

const Item = styled(Box)`
  max-width: ${16 * 15}px;
  background-color: ${props => props.theme.colors.grey[2]};
  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);

  &:last-child {
    span {
      border-bottom: none;
    }
  }

  &:hover {
    background-color: ${props => props.theme.colors.grey[1]};
  }
  &:active {
    background-color: ${props =>
      props.theme.colors.grey[1] && rgba(props.theme.colors.grey[1], 0.5)};
  }
`;
Item.defaultProps = {};

const ItemContent = styled(Box)`
  display: block;
  color: ${props => props.theme.colors.text};
  line-height: 1.5;
  border-bottom: 1px solid;
  border-color: ${props => props.theme.colors.grey[1]};
`;
ItemContent.defaultProps = {
  is: "span",
  mx: 4,
  py: 4
};

const MenuItem = props => (
  <Item is={Link} to={props.to} onFocus={props.onFocus} onBlur={props.onBlur}>
    <ItemContent children={props.children} />
  </Item>
);

class DropdownMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false
    };
  }
  onFocus = () => {
    this.setState({ focused: true });
  };
  onBlur = () => {
    this.setState({ focused: false });
  };
  render() {
    return (
      <Wrapper className={this.state.focused ? "focused" : ""}>
        {this.props.parent && (
          <Parent
            children={this.props.parent}
            to={this.props.parentTo}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
        )}
        {this.props.items && (
          <ThemeProvider theme={theme}>
            <Container>
              {this.props.items.map((item, index) => {
                if (item.node.lang === this.props.lang) {
                  return (
                    <MenuItem
                      key={item.node.data.title[0].text}
                      children={item.node.data.title[0].text}
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      to={
                        "/" +
                        this.props.lang +
                        "/" +
                        (this.props.linkType ? this.props.linkType + "/" : item.node.type === 'campaign' ? 'campaign/' : "") +
                        item.node.uid
                      }
                    />
                  );
                } else {
                  return null;
                }
              })}
            </Container>
          </ThemeProvider>
        )}
      </Wrapper>
    );
  }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.js